// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Questionnaire {
  public id!: string;

  public title!: string;

  public static fromDto(dto: any): Questionnaire {
    const questionnaire: Questionnaire = new Questionnaire();
    questionnaire.id = dto.id;
    questionnaire.title = dto.title;
    return questionnaire;
  }
}
